import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import Mixpanel from "mixpanel-browser";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TagManager from 'react-gtm-module';

import { loginData } from "../features/auth/login/loginSlice";
import Fields from "../components/form-components/Fields";
import Button from "../components/form-components/Button";
import Image from "../components/form-components/Image";
import Label from "../components/form-components/Label";

import { OK } from "../constants/statusCode";
import { setSession } from "../utils/localSession";
import loginPageValidations from "../validations/auth/loginPageValidations";
import logo from "../assets/images/DocoMatic_beta.svg";
import eyeline from "../assets/images/eyelineicn.svg";
import eye from "../assets/images/eyeicn.svg";
import VerifyEmailModal from "../common/modal/VerifyEmailModal";
import ActivateAccountModal from "../common/modal/ActivateAccountModal";
import { showError } from "../utils/messageHelper";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [togglePassword, setTogglePassword] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [activateAccountModal, setActivateAccountModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams != null && searchParams.get("email_verify") != null) {
      setShowModal(true);
    } else if (
      searchParams != null &&
      searchParams.get("activate_account") != null
    ) {
      setActivateAccountModal(true);
    }
  }, []);

  return (
    <>
      {showModal && (
        <VerifyEmailModal
          isOpen={showModal}
          toggle={() => setShowModal(false)}
        />
      )}
      {activateAccountModal && (
        <ActivateAccountModal
          isOpen={activateAccountModal}
          toggle={() => setActivateAccountModal(false)}
        />
      )}
      <Formik
        initialValues={{
          email: "",
          password: "",
          remember: false,
        }}
        validationSchema={loginPageValidations}
        onSubmit={async (values) => {
          Mixpanel.track("Login button clicked", { Page: "Login page" });
          // values.remember = null;
          const { payload } = await dispatch(loginData(values));
          if (payload.status === OK) {
            TagManager.dataLayer({
              event: 'loginSuccess'
            });
            Mixpanel.identify(payload.data.responseData.user.id);
            setSession(
              payload.data.responseData.access_token,
              values.remember ? payload.data.responseData.refresh_token : "",
              payload.data.responseData.user.uuid,
              payload.data.responseData.user
            );
            navigate("/dashboard");
          } else {
            showError(payload?.response?.data?.responseMessage);
          }
        }}
      >
        {({
          values,
          handleChange,
          handleBlur,
          touched,
          errors,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <Form>
            <div className="form-pages d-flex align-items-center">
              <div className="form-box">
                <span className="logo text-center">
                  <Image src={logo} alt="" />
                </span>
                <h1>Sign into your account</h1>
                <div className="form-group">
                  <Fields
                    type="email"
                    placeholder="Email"
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    name="email"
                    value={values.email}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group form-grp-passsword">
                  <Fields
                    type={togglePassword ? "text" : "password"}
                    placeholder="Password"
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    name="password"
                    value={values.password}
                    className="form-control"
                    onChange={handleChange}
                  />
                  <span
                    className={`icon-${togglePassword ? "Hide" : "Hide"}`}
                    onClick={() => setTogglePassword(!togglePassword)}
                  >
                    <img
                      className="eye-icn"
                      src={togglePassword ? eye : eyeline}
                      alt="show password"
                    />
                  </span>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-check">
                        <Fields
                          type="checkbox"
                          id="flexCheckChecked"
                          touched={touched}
                          errors={errors}
                          onBlur={handleBlur}
                          name="remember"
                          value={values.remember}
                          className="form-check-input"
                          onChange={handleChange}
                        />
                        <Label
                          className="form-check-label"
                          htmlFor="flexCheckChecked"
                        >
                          Remember me
                        </Label>
                      </div>
                    </div>
                    <div className="col-md-6 text-end">
                      <Link to="/forgotPassword" className="forgot-link">
                        Forgot Password?
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <Button
                    type="submit"
                    className="btn btn-primary btn-lg w-100 mt-1"
                    disabled={isSubmitting}
                  >
                    Sign In
                  </Button>
                </div>
                {/* <div className="form-group mt-1">
                  <p className="form-msg">
                    By creating account, I agree to{" "}
                    <a
                      href="https://www.docomatic.ai/terms-of-use/"
                      target={"_blank"}
                    >
                      {" "}
                      Terms of Use
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://www.docomatic.ai/privacy-policy/"
                      target={"_blank"}
                    >
                      Privacy Policy
                    </a>
                  </p>
                </div> */}
                <h4>
                  Don’t have an account yet ?{" "}
                  <Link to="/signup" className="form-link">
                    Sign Up
                  </Link>
                </h4>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
